import { PickingListCalculationRowShape } from '../../api/api_data_types'

export default function pickingListRemainingQuantity(row: PickingListCalculationRowShape): number {
  const remaining = Number(row.estimated_quantity) - Number(row.job_cost_quantity)
  return Math.round(remaining * 10000) / 10000
}
